<script setup lang="ts">
</script>

<template>
    <div class="flex flex-col w-full h-full items-start overflow-y-auto pt-6">
        <div class="h-full w-full bg-gradient-to-b from-gray-900 to-gray-850">
            <div class="text-center top-0 w-full px-4 lg:px-6">

                <img src="@/assets/images/carbucks-dark-mode.png"
                    class="w-4/5 mx-auto transition-all duration-150"
                />

                <h1
                    class="text-xl mb-4 font-bold italic" style="color: #00addf">
                    DEALER MODE
                </h1>
                
                <h1
                    class="text-l mb-4 font-bold">
                    SORRY!
                </h1>

                <p
                    class="text-sm lg:text-base mb-4 opacity-70">
                    You are using a Dealer Mode account and don’t have access to this tab.
                </p>

                <p
                    class="text-sm lg:text-base mb-4 opacity-70">
                    To activate a customer’s vehicle select the My Garage tab.
                </p>
            </div>
        </div>
    </div>
</template>